//go-top function
var goTop = $('.go-top');
var lastScrollTop = 0;
    if (goTop != null) {


    $(function(){

      //Scroll event
      $(window).scroll(function(){
        var st = $(this).scrollTop();
        if (st < lastScrollTop){$('.go-top').fadeIn(400);}
        if (st > lastScrollTop){$('.go-top').fadeOut(400);}
        lastScrollTop = st;
        if (st == 0){$('.go-top').fadeOut(400);}

      });

      //Click event
      $('.go-top').click(function () {
        $("html, body").animate({ scrollTop: "0" }, 500);});
    });

  }